import 'bootstrap';
import 'jquery-countdown';

init_banner();

jQuery( function( $ ) {

    // Grid View
    function listView() {
        var savedLayout = localStorage.getItem("wodbsLayout") || "grid";

        $(".wodbs-video-archive__loop").addClass(savedLayout + "-view");
        $(".content-card.video-card-lg").each(function() {
            $(this).addClass(savedLayout + "-view");
        });

        $(".toggle-btn[data-layout='" + savedLayout + "']").addClass("active");

        $(".toggle-btn").click(function() {
            var layout = $(this).data("layout");

            $(".toggle-btn").removeClass("active");
            $(this).addClass("active");

            $(".wodbs-video-archive__loop").removeClass("list-view grid-view").addClass(layout + "-view");
            $(".content-card.video-card-lg").each(function() {
                $(this).removeClass("list-view grid-view").addClass(layout + "-view");
            });

            localStorage.setItem("wodbsLayout", layout);
        });
    }
    
    listView();

    $(document).on('facetwp-loaded', function() {
        listView();
    });



    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    // Toggle Video Archive
    $(".wodbs-video-archive__filter-toggle").click(function() {
        // Zoek de bijbehorende filter-content en toggle de weergave
        $(this).next(".wodbs-video-archive__filter-content").slideToggle(300);
        
        // Voeg een actieve class toe/verwijder deze voor styling (optioneel)
        $(this).toggleClass("active");
    });

    // Video poster
    $(".video-wrapper").on('click', function() {
        var youtubeID = $(this).data("youtube-id");
        var iframe = '<iframe width="100%" height="400px" src="https://www.youtube.com/embed/' + youtubeID + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        
        $(this).html(iframe);
    });

    // Video->Column Equalizer Scroll
    var titleHeight = $('.content-card.sidebar .title-row').outerHeight();
    var leadingHeight = $('#leading-box').outerHeight();

    $('.content-card.sidebar .scroll-container').css({
        'height': 'calc(100% - ' + titleHeight + 'px)'
    });
    
    $('.content-box').not('#leading-box').css('height', leadingHeight);

    $(document).on("click", "#read-more", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $("#page_content").offset().top - headerHeight - 30
        }, 800);
    });
    
    

    //Header offset
    function on_resize(){
        // Set header offset css var
        // Use the toggler as reference size.
        var header = document.getElementsByClassName('navbar')[0];
        var offset = header.getBoundingClientRect().bottom;
        var height = header.clientHeight;
        document.documentElement.style.setProperty('--header-offset', offset + "px");
        document.documentElement.style.setProperty('--header-height', height + "px");

        //Footer toggle open
        var $footer_details = jQuery(".footer-details");
        if (jQuery(window).width() > 768) {
            $footer_details.prop("open", true);
        } else {
            $footer_details.removeAttr("open");
        }
    }
    on_resize();
    window.addEventListener('resize', on_resize, true);

    init_faq();
    init_banner();
    dynamify_modals();
    find_timer();
    qty_buttons();
    related_shoppingcart_products();

    jQuery('.menu-item.login a').tooltip({
      placement: 'bottom',
      title: 'Inloggen'
    });

    jQuery('.navbar-search-toggler').tooltip({
      placement: 'bottom',
      title: 'Zoeken'
    });

    jQuery('.nav-link.cart-link').tooltip({
      placement: 'bottom',
      title: 'Winkelmand'
    });

    update_cart_count();
});

function init_banner() {

    if (document.querySelector('body > #banner')) {
        var seen = getCookie('wodbs-banner');

        if (!seen || window.self !== window.top) {
            document.querySelector('body > #banner').classList.add('show');

            document.querySelector('body > footer').style.marginBottom = document.querySelector('body > #banner').offsetHeight + 'px';
        }
        if (!seen) {
            setCookie('wodbs-banner', true, 31);
        }

        document.querySelector('#banner-close').onclick = () => {

            document.querySelector('body > footer').style.marginBottom = '0px';

        };

    }
}

function init_faq() {

    // For each FAQ block
    document.querySelectorAll('.schema-faq').forEach((faq, i) => {

        // For each FAQ item within block
        faq.querySelectorAll('.schema-faq-section').forEach((item, j) => {

            // On click on question
            item.querySelector('.schema-faq-question').onclick = () => {

                // Add active class
                item.classList.toggle('schema-faq-section--active');

            };

        });

    });

}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function dynamify_modals() {

    $('#modal-activecampaign').on('show.bs.modal', function(event) {
        var modal = $(this);
        var button = $(event.relatedTarget); // Button that triggered the modal

        var form = button.data('form') ?? modal.data('form'); // Extract info from data-* attributes

        var placeholder = document.createElement('div');
        placeholder.setAttribute('class', 'placeholder');

        var formid = document.createElement('div');
        formid.setAttribute('class', '_form_' + form);

        var script = document.createElement('script');
        script.setAttribute('src', 'https://wijzeroverdebasisschool.activehosted.com/f/embed.php?nostyles=1&id=' + form);
        script.setAttribute('type', 'text/javascript');

        placeholder.append(formid);
        placeholder.append(script);

        modal.find('.modal-body .placeholder').replaceWith(placeholder);

        check_form_for_email_field('._form_'+ form +' [name=email]');
    });
}

function check_form_for_email_field(form_class) {
    setTimeout(function() {
      if ($(form_class).length) {
        var footer_mail = $("[name=footer-news-email]").val();
        console.log(footer_mail);
        if (footer_mail) {
            console.log($(form_class));
            $(form_class).val(footer_mail);
        }
      } else {
        check_form_for_email_field(form_class);
      }
    }, 100);
}


function find_timer() {

    const mode = wodbs.countdown_type;
    const days = parseInt(wodbs.countdown_days);
    const date = wodbs.countdown_date;
    const redirect = wodbs.countdown_redirect;
    const cookieName = 'wodbs-countdown-js-' + wodbs.post_id;

    $(".wp-block-wodbs-countdown").each(function() {
        var firstRun = true;
        if (mode == "countdown") {
            $(this).find('.countdown-datum').countdown(date, {elapse: false})
                .on('update.countdown', function(event) {
                    print_timer( $(this), event);
                    firstRun = false;
                })
                .on('finish.countdown', function( event ) {
                    print_timer( $(this), event);

                    if (redirect != '') {
                        window.location.replace(redirect);
                    } else {
                        // Only reload once we've rendered at least one update to prevent a redirect loop.
                        if( firstRun != true ){
                            window.location.reload();
                        }
                    }
                });
        }
        else if (mode == "userlanding") {

            if (!getCookie(cookieName)) {
                setCookie(cookieName, Date.now(), '365');
            }

            if (getCookie(cookieName)) {
                const cookieTimestamp = parseInt(getCookie(cookieName));
                const cookieDate = new Date(cookieTimestamp + (days * 24 * 60 * 60 * 1000));

                $(this).find('.countdown-datum').countdown(cookieDate, {elapse: false})
                    .on('update.countdown', function(event) {
                        print_timer( $(this), event);
                        firstRun = false;
                    })
                    .on('finish.countdown', function( event ) {
                        if( firstRun != true ){
                            if (redirect != '') {
                                window.location.replace(redirect);
                            } else {
                                window.location.reload();
                            }
                        }
                    });
            }
        }
    });
}

function print_timer(thisCountDown, event) {
    if (event.offset.totalDays > 0) {
        if (event.offset.totalDays == 1) {
            thisCountDown.html(event.strftime(''
                + '<span class="trm-timer">%-D Dag </span>'
                + '<span class="trm-timer">%H:</span>'
                + '<span class="trm-timer">%M:</span>'
                + '<span class="trm-timer">%S</span> '));
        }
        else {
            thisCountDown.html(event.strftime(''
                + '<span class="trm-timer">%-D Dagen </span>'
                + '<span class="trm-timer">%H:</span>'
                + '<span class="trm-timer">%M:</span>'
                + '<span class="trm-timer">%S</span> '));
        }
    }
    else {
        thisCountDown.html(event.strftime(''
            + '<span class="trm-timer">%H:</span>'
            + '<span class="trm-timer">%M:</span>'
            + '<span class="trm-timer">%S</span> '));
    }
}

function qty_buttons(){

    $('.quantity').each( function() {

        const $qty = $(this).find('.qty');
        $(this).on('click', '.btn-quantity-before', function( e ){
            e.preventDefault();
            $qty.val( parseInt( $qty.val() ) - 1 );

            $qty.trigger("change");
        });

        $(this).on('click', '.btn-quantity-after', function( e ){
            e.preventDefault();
            $qty.val( parseInt( $qty.val() ) + 1 );

            $qty.trigger("change");
        });

    });

    var timeout; 
    $('div.woocommerce').on('change keyup mouseup', '.qty', function(){ 
        if (timeout != undefined) clearTimeout(timeout);
        if (jQuery(this).val() == '') return;
        timeout = setTimeout(function() {
            jQuery('[name="update_cart"]').trigger('click');
        }, 1000 );
    });

}

function related_shoppingcart_products() {

    jQuery('#related_shopping_cart_groep_select').on('click', '.dropdown-item', function( e ){
        var select = $(e.delegateTarget).find('.dropdown-toggle');
        var group = $(e.target).data('groep');

        $(select).html( e.target.innerHTML );

        jQuery("#related_shopping_cart_products li:not([data-group='"+group+"'])").addClass("d-none");
        jQuery("#related_shopping_cart_products li[data-group='"+group+"']").removeClass("d-none");
    });

    jQuery("#related_shopping_cart_groep_select").on('change',function() {

        var group = $(this).val();
        jQuery("#related_shopping_cart_products li:not([data-group='"+group+"'])").addClass("d-none");
        jQuery("#related_shopping_cart_products li[data-group='"+group+"']").removeClass("d-none");

    });

    jQuery(document.body).on('removed_from_cart updated_cart_totals', function () {
        location.reload();
    });
}

function update_cart_count(){
    const count = getCookie('wodbs-cart_count') ?? '';
    jQuery( '#shop-nav .contents_count' ).html( count )
}